
var navbarFixedPosition = {
    go: function () {

        // --------------------------------------------------------------------
        // on document ready
        // --------------------------------------------------------------------

        $(function () {
            $body = $('.has-navbar-fixed-top').first();
            $navi = $('.kit-navbar .fixed-top').first();

            if (!$body.length || !$navi.length) {
                return;
            }

            $body.attr(
                'style',
                'padding-top: ' + $navi.outerHeight(true) + 'px');
        });
    }
}
navbarFixedPosition.go();
